const T = {
  bg0: "#040d1a",
  bg1: "#060f20",
  bg2: "#0a1628",
  bg3: "#0e1c32",
  bgCard: "#070e1e",
  blue: "#3b82f6",
  blueDim: "#1d4ed8",
  blueGlow: "rgba(59,130,246,0.18)",
  blueGlow2: "rgba(59,130,246,0.08)",
  blueLight: "#93c5fd",
  white: "#ffffff",
  gray1: "#c8d8f0",
  gray2: "#6b86b8",
  gray3: "#1e2f50",
  border: "rgba(59,130,246,0.2)",
  borderDim: "rgba(59,130,246,0.08)",
  mono: "'JetBrains Mono','Fira Mono','Courier New',monospace",
  sans: "'Barlow','Inter','Segoe UI',system-ui,sans-serif",
};

export default T;
